import TransactionDetail from "../components/TransactionDetail";
function Show() {
  return (
    <section>
      <h2>Transaction Details</h2>
      <TransactionDetail />
    </section>
  );
}

export default Show;
